<template>
    <div id="app">
        <transition name="router-fade" mode="out-in">
            <router-view class="router-view"></router-view>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'app',
    created() {
        let baseUrl = this.$store.state.baseUrl.url;
        if (baseUrl) {
            // 已经赋值
        } else {
            // 需要赋值
            let url = location.href;
            this.$store.dispatch('setBaseUrl', url);
        }
    }
}
</script>

<style lang="less">
html, body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
}
*{
    -webkit-text-size-adjust: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color:transparent;
    -webkit-touch-callout:none; /*系统默认菜单被禁用*/
    -webkit-user-select:none; /*webkit浏览器*/
    -khtml-user-select:none; /*早期浏览器*/
    -moz-user-select:none;/*火狐*/
    -ms-user-select:none; /*IE10*/
    user-select:none;
}

input,textarea {
    -webkit-user-select:auto; /*webkit浏览器*/
    margin: 0px;
    padding: 0px;
    outline: none;
}
#app {
    margin: 0 auto;
    width: 750px;
    height: 100%;
    font-family: 'Microsoft YaHei',arial,helvetica,sans-serif;
}
.mint-msgbox-btn, .mint-msgbox-title, .mint-msgbox-message {
    font-size: 16px; /*no*/
}

.mint-msgbox {
    width: 80%;
}

.mint-msgbox-btns {
    height: 50px; /*no*/
    line-height: 50px; /*no*/
}

.mint-msgbox-btn {
    padding-top: 5px; /*no*/
}

.mint-msgbox-message {
    padding: 0 5px 8px; /*no*/
    color: #333;
    line-height: 1.6;
}

.mint-msgbox-content .mint-msgbox-message {
    font-size: 16px; /*no*/
}

.mint-msgbox-confirm {
    color: #46C281;
}

.mint-msgbox{
    padding-top: 12px; /*no*/
}
.mint-msgbox-content, .mint-msgbox-cancel {
    border-color: #E4E4E4;
}


.mint-toast {
        z-index: 9999999;
}
.router-view {
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// App.vue?5906606e